import { Box, Flex, Text, useBreakpointValue } from "@chakra-ui/react";
import { contactIcon, locationIcon } from "../component/constant/Icons";
import ContactForm from "../component/Form/ContactForm";

const Contact = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  return (
    <Box
      display={"flex"}
      p={[0, 0, 0, 20, 0]}
      flexDirection={["column", "column", "row", "row", "row"]}
      justifyContent={"center"}
      paddingTop={["0px", "0px", "0px", "50px", "80px"]}
      background="linear-gradient(180deg, #f3ffe1 0%, #fff 100%), #f3ffe1"
      paddingBottom={["0px", "0px", "0px", "50px", "150px"]}
    >
      <Box w={["100%", "100%", "50%", "50%", "50%"]}>
        <Box p={["20px", "0px"]}>
          <Text
            color={"#404040"}
            fontFamily="Inter"
            fontSize={["30px", "30px", "50px", "50px", "86px"]}
            fontStyle="normal"
            fontWeight={"700"}
            mt={["5px", "5px", "20px", "0px", "80px"]}
          >
            Contact us
          </Text>
          <Text
            color={"#707070"}
            fontFamily="Inter"
            fontSize={["10px", "10px", "12px", "13px", "16px"]}
            fontStyle="normal"
            fontWeight={"700"}
            width={["auto", "auto", "auto", "300px", "450px"]}
          >
            We would love to hear from you! Whether you have a query, feedback,
            or need more information about our services, our team is here to
            assist you. Your concerns and suggestions help us improve and
            deliver better solutions to the agricultural community.
          </Text>
        </Box>
        {!isMobile && (
          <Flex
            justifyContent={"space-between"}
            gap={"20px"}
            display={"flex"}
            marginTop={["5px", "20px", "200px", "170px", "170px"]}
          >
            <Box>
              {locationIcon()}
              <Text
                color={"#404040"}
                fontFamily="Inter"
                fontSize={["10px", "14px", "18px", "20px", "24px"]}
                fontStyle="normal"
                fontWeight={"700"}
              >
                Our Address
              </Text>
              <Text
                color={"#707070"}
                fontFamily="Inter"
                fontSize={"16px"}
                fontStyle="normal"
                fontWeight={"700"}
                width={["100%", "100%", "100%", "100%", "350px"]}
                mt={"10px"}
              >
                C/O Reena Chaudhary, Flat No. 602, Kumar Ranjan Enclave, Near
                Bahadurpur Flyover, Kankarbagh, Patna, Bihar, 800020{" "}
              </Text>
            </Box>
            <Box width={["200px", "200px", "200px", "300px", "450px"]}>
              {contactIcon()}
              <Text
                color={"#404040"}
                fontFamily="Inter"
                fontSize={["10px", "14px", "18px", "20px", "24px"]}
                fontStyle="normal"
                fontWeight={"700"}
              >
                Contact Us
              </Text>
              <Text
                color={"#707070"}
                fontFamily="Inter"
                fontSize={["6px", "10px", "12px", "13px", "16px"]}
                fontStyle="normal"
                fontWeight={"700"}
                mt={"15px"}
                w={"200px"}
              >
               +91 7520022055
              </Text>
              <Text
                color={"#707070"}
                fontFamily="Inter"
                fontSize={["6px", "10px", "12px", "13px", "16px"]}
                fontStyle="normal"
                fontWeight={"700"}
                mt={"15px"}
              >
                info@sonamagrotech.com
              </Text>
            </Box>
          </Flex>
        )}
      </Box>
      <Box
        border={"1px solid #ccc"}
        boxShadow={"0px 4px 4px 4px rgba(0, 0, 0, 0.25)"}
        borderRadius={"28px"}
        bg={"#fff"}
        p={{ base: "20px", lg: "0px" }}
        m={{ base: "10px", lg: "0px" }}
      >
        <ContactForm />
      </Box>
    </Box>
  );
};

export default Contact;
